import { render, staticRenderFns } from "./status-flag.vue?vue&type=template&id=04c59e2b"
import script from "./status-flag.vue?vue&type=script&lang=js"
export * from "./status-flag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports